import { mapState } from "vuex";

import { REQUEST_TEMPLATES, UPDATE_TEMPLATES } from ":actions";

import { TemplatesUpdatedNotification } from "%notifications";

import { getUpdatedTemplates } from "%utils/templates";

import { WithDispatcherProgress } from "%mixins";

export default ({ templates, json = [] }) => ({
  mixins: [WithDispatcherProgress],

  computed: mapState({
    templates: state => state.content.templates
  }),

  methods: {
    updateChangedTemplates(fields, fieldsNames, hookBefore, hookAfter) {
      const updatedTemplates = getUpdatedTemplates(
        fields,
        this.templates,
        json
      );
      const anyChanges = Object.keys(updatedTemplates).length > 0;

      if (anyChanges) {
        hookBefore && hookBefore();
        return this.$store
          .dispatch(UPDATE_TEMPLATES, {
            templates: updatedTemplates,
            json
          })
          .then(() =>
            this.$emit("push-notification", {
              component: TemplatesUpdatedNotification,
              props: {
                templates: updatedTemplates,
                fields: fieldsNames
              }
            })
          )
          .finally(() => hookAfter && hookAfter());
      }
    },

    areAnyTemplateChanges(fields) {
      return (
        Object.keys(getUpdatedTemplates(fields, this.templates, json)).length >
        0
      );
    },

    applyTemplates(target, map = {}, forEach = () => {}) {
      templates.forEach(t => {
        const mapped = map[t] ? map[t](this.templates[t]) : this.templates[t];
        target[t] = mapped;
        forEach(t, mapped);
      });
    },

    requestTemplates() {
      return this.dispatchWithProgress("templates", REQUEST_TEMPLATES, {
        templates,
        json
      });
    },

    templatesLoaded() {
      return this.actions.templates === "ok";
    }
  }
});
